var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandlinePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17104 4.03246C10.9044 4.03246 11.6438 4.7718 11.6438 6.50519H13.2923C13.2923 3.847 11.8292 2.38396 9.17104 2.38396V4.03246ZM11.9916 8.51883C11.8332 8.37487 11.6251 8.2981 11.4112 8.30471C11.1973 8.31133 10.9943 8.40081 10.8451 8.55427L8.87266 10.5827C8.3979 10.4921 7.44342 10.1945 6.46092 9.21449C5.47842 8.23116 5.18086 7.27422 5.09267 6.80275L7.11949 4.8295C7.27314 4.68042 7.36275 4.4774 7.36937 4.26341C7.37598 4.04943 7.29908 3.84126 7.15493 3.68298L4.10934 0.334064C3.96514 0.175278 3.76471 0.0789631 3.55063 0.0655736C3.33655 0.0521841 3.12569 0.122775 2.96282 0.262354L1.1742 1.79628C1.0317 1.9393 0.946644 2.12964 0.935171 2.33121C0.922807 2.53727 0.687073 7.41846 4.47201 11.205C7.77394 14.5062 11.91 14.7477 13.0491 14.7477C13.2156 14.7477 13.3178 14.7427 13.345 14.7411C13.5466 14.7298 13.7368 14.6443 13.8791 14.5012L15.4122 12.7118C15.5519 12.549 15.6226 12.3382 15.6094 12.1241C15.5962 11.91 15.5 11.7096 15.3413 11.5652L11.9916 8.51883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandlinePhone);
export default __webpack_public_path__ + "static/media/landline_phone.081fa6ff5dd858b62f4c78f380ff2831.svg";
export { ForwardRef as ReactComponent };